export default __webpack_public_path__ + "static/media/production.8eca703d.png";